import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import {addEvent, getAllEntity, getEntity, getOneEntity, scheduleMeeting } from "http/fundLync/entityAndAddress.helper";
import ToastDialog from "components/Common/ToastDialog";
import { useNavigate,useLocation } from "react-router-dom";
import JoditEditor, { Jodit } from "jodit-react";
import Select from "react-select";
import { getUser, getUserByEntityType } from "http/fundLync/user.helper";
import { getDealInfo, getEntityWiseDeal } from "http/fundLync/deal.helper";
import { EditorState} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { decryptedValue } from "common/utility";


  // Custom styles for react-select
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, 
    })
  };



const ScheduleMeetngForm = ({ onSchedule, onCancel}) => {
  const navigate = useNavigate();
  const [meetingStatus,setMeetingStatus] = useState([]);
  const [medium,setMedium] = useState([]);
  const [relatedTo,setRelatedTo] = useState([]);
  const [selectedRelatedTo, setSelectedRelatedTo] = useState(null);
  const [entity, setEntity] = useState([]);
  const [invitees, setInvitees] = useState([]);
  const [owner, setOwner] = useState([]);
  const [deals, setDeals] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [entityName, setEntityName] = useState('');
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const currentDate = new Date().toISOString().split("T")[0];
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);
  const [encodedId, setEncodedId] = useState('')
  const [ entityId, setEntityId] = useState('')
  const [dealName, setDealName] = useState('');
  const [encodedIdDeal, setEncodedIdDeal] = useState('')
  const [ dealId, setDealId] = useState('')
  const [selecteddealId, setSelecteddealId] = useState(null);

  let userDetails = decryptedValue(localStorage.getItem("user"));
  

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const entityName = queryParams.get('entityName');
    if (entityName) {
      setEntityName(entityName);
    }
    const dealName = queryParams.get('dealName');
    if (dealName) {
      setDealName(dealList);
    }
    const userDetails = decryptedValue(localStorage.getItem("user"));
    const type = queryParams.get('type');
    if (type) {
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("entityId"))
        setEncodedIdDeal(urlParams.get("id"))
        setDealId(atob(encodedIdDeal))
        setEntityId(encodedId)
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
    }else{
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
    }
    

  }, [location.search, entityId, encodedId, dealId, encodedIdDeal]);
  
  const [timezones, setTimezones] = useState([
    { value: "Indian Standard Time (IST)", label: "Indian Standard Time (IST)" }
  ]);

  const [values, setValues] = useState({
    invitees: [],
  });

  const [showNestedDropdown, setShowNestedDropdown] = useState(false);
  
  const editor = useRef(null)
  
  const initialValues = {
    entity: "",
    deal: "",
    title: "",
    date: "",
    startTime: "",
    endTime: "",
    timezone: "Indian Standard Time (IST)",
    meetingStatus: "",
    invitees: [],
    medium: "",
    location: "",
    description: "",
  };

  //Form Validation
  const validationSchema = Yup.object({
    // entity: Yup.string().required("Entity is required"),
    entity: Yup.string().when([], {
      is: () => !encodedId,
      then: Yup.string().required("Entity is required"),
      otherwise: Yup.string(),
    }),
    deal: Yup.string(),
    title: Yup.string().required("Title is required"),
    date: Yup.string().required("Date is required"),
    startTime: Yup.string().required("Start Time is required"),
    endTime: Yup.string().required("End Time is required"),
    meetingStatus: Yup.string().required("Status is required"),
    invitees: Yup.array().required("Invitees is required").min(1, "At least one invitee is required"),
  });

   // Handling Form Submit
  const handleSubmit = (values) => {

    // Extract text content from HTML string
    const DescriptionText = Jodit.modules.Helpers.stripTags(values.description);
      
    //const inviteesString = values.invitees.map((invitee) => invitee.value).join(',');
    const inviteesString = [...values.invitees.map((invitee) => invitee.value), userDetails.email].join(',');
    

   // Meeting Body
    const newMeeting = {
        entityId: selectedEntityId || entityId,
        dealId: selecteddealId || dealId,
        title: values.title,
        date: values.date,
        startTime: values.startTime || '',
        endTime: values.endTime || '',
        timezone: values.timezone || '',
        meetingStatus: values.meetingStatus || '',
        invitees: inviteesString || '',
        medium: values.medium || '',
        location: values.location ||'',
        description: DescriptionText || '',
      };

    scheduleMeeting(newMeeting)
        .then((response) => {
          if (response) {
              setToastInfo({
                message: "Meeting Scheduled Successfully",
                showToast: true,
                role: "success",
              });
  
              setTimeout(() => {
                if ((encodedId && entityName) || (!encodedId && !entityName)) {
                  window.history.back();
                } else {
                  onSchedule();
                  handleCancel();
                }
              }, 1000);
          } else {
            setToastInfo({
              message: "Meeting Scheduled Failed",
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        
    addEvent(newMeeting)
      .then((eventResponse) => {
          console.log("Event created in Microsoft Teams:", eventResponse);
      })
      .catch((error) => {
          console.error("Error creating event in Microsoft Teams:", error);
      });
 };
 
  //Handling Form Cancel
  const handleCancel = () => {
     onCancel();
    // window.history.back();
  };
  const user = decryptedValue(localStorage.getItem("user"));
  useEffect(() => {

  //Fetching Meeting Status
  getDropDownList({ dropdownName: "Meeting_Status" })
  .then((response) => {
    const dropdownValues =
      response.data?.rows?.find((dv) => dv.dropdownName == "Meeting_Status")
        ?.dropdownValues || [];
        setMeetingStatus(dropdownValues);
  })
  .catch((error) => {"Error fetching data", error });

  //Fetching Meeting Medium
  getDropDownList({ dropdownName: "Medium" })
  .then((response) => {
    const dropdownValues =
      response.data?.rows?.find((dv) => dv.dropdownName === "Medium")
        ?.dropdownValues || [];

    // Filter out the unwanted values
    const filteredDropdownValues = dropdownValues.filter(
      (dv) => !["google meet", "offline"].includes(dv.displayName.toLowerCase())
    );

    // Set the filtered values to the state
    setMedium(filteredDropdownValues);
  })
  .catch((error) => {
    console.error("Error fetching data", error);
  });

  // Fetching Meeting Related To
  getDropDownList({ dropdownName: "Related_To" })
  .then((response) => {
    const dropdownValues =
      response.data?.rows?.find((dv) => dv.dropdownName == "Related_To")
        ?.dropdownValues || [];
        const formattedValues = dropdownValues.map(item => ({
          value: item.dropdownValue,
          label: item.displayName
        }));
        setRelatedTo(formattedValues);
  })
  .catch((error) => {"Error fetching data", error });


    //Get Owner List 
    getUserByEntityType()
      .then((response) => {
        const formattedValues = response.map(item => ({
          value: `${item.firstName} ${item.lastName}`,
          label: `${item.firstName} ${item.lastName}`
        }));
        setOwner(formattedValues);
      })
      .catch((error) => {
        console.log(error)
      })

    
    //Getting Entity Related to Entity 
    if(encodedIdDeal){
      getDealInfo({ id : dealId })
      .then((response) => {
        if (response.code == 200 && response.status) {
          setDealName(response.data.dealName)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    }
      if(encodedId){
        getOneEntity({ entityId : entityId })
        .then((response) => {
          if (response.code == 200 && response.status) {
            setEntity(response.data[0].entityName);
          }
        })
        .catch((error) => {
          console.log(error)
        })
      }else{
       let totalValues;
        getEntity({user})
         .then((response) =>{
          totalValues = response.data.totalItems; 
            getEntity({limit:totalValues, user, columnName : "entityName", sortingOrder :"asc"})
            .then((response) => {
                setEntityList(response?.data?.data);
            })
            .catch((error) => {
              console.log(error)
            })
         }) 
        .catch((error) => {
          console.log(error)
        })

      }

      //Getting deall
      if(encodedId){
        getEntityWiseDeal({ entityId: entityId })
        .then((response) => {
          if (response?.data?.rows.length > 0) {
            setDealList(response.data.rows);
          } else {
            setDealList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
     }


}, [entityId, encodedId, encodedIdDeal]);

  useEffect(() =>{
    fetchAndSetInvitees(selectedEntityId);
  },[selectedEntityId])

    const fetchAndSetInvitees = async (id) => {
      try {
        const userResponse = await getUser({ entityId: id });
        let inviteesList = [];

        if (userResponse.code === 200 && userResponse.status) {
          let formattedUserValues = userResponse?.data?.data.map(item => ({
            value: item.email,
            label: item.lastName ? `${item.firstName} ${item.lastName}` : item.firstName
          }));
    
          const defaultInvitee = {
            value: userDetails.email,
            label: userDetails.lastName ? `${userDetails.firstName} ${userDetails.lastName}` : userDetails.firstName
          };
          formattedUserValues = formattedUserValues.filter(item => item.value !== defaultInvitee.value);
    
          inviteesList = [defaultInvitee, ...formattedUserValues];
        }

        const ownerResponse = await getUserByEntityType();
        const formattedOwnerValues = ownerResponse.map(item => ({
          value: item.email,
          label: item.lastName ? `${item.firstName} ${item.lastName}` : item.firstName
        }));

        const combinedInvitees = [...inviteesList, ...formattedOwnerValues];
        const uniqueInvitees = Array.from(new Set(combinedInvitees.map(item => item.value)))
          .map(email => combinedInvitees.find(item => item.value === email));
    
        setInvitees(uniqueInvitees);
      } catch (error) {
        console.log(error);
      }
    };

    const handleDealChange = (e) => {
      const selecteddealId = e.target.value;
        setSelecteddealId(selecteddealId);
    }

    const handleEntityChange = (e) => {
      const selectedEntityId = e.target.value;
      setSelectedEntityId(selectedEntityId);
  
      getEntityWiseDeal({ entityId: selectedEntityId || entityId })
        .then((response) => {
          if (response?.data?.rows.length > 0) {
            setDealList(response.data.rows);
            setShowNestedDropdown(true);
          } else {
            setDealList([]);
            setShowNestedDropdown(false);
          }
        })
        .catch((error) => {
          setDealList([]);
          setShowNestedDropdown(false);
        });
      
    };


    const handleOptionChange = (value) => {
      setInputValue(value);
    };
  
    const handleCreateInvitees = () => {
      const newInvitees = {
        value: inputValue.toLowerCase().replace(/\s+/g, ''),
        label: inputValue,
      };
      setInvitees([...invitees, newInvitees]);
    };

    const config = {
      removeButtons: ['about'],
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
    };



  return (
    <React.Fragment>
      <div className="page-content" style={encodedId === null || entityName ? {} : {marginTop: "-80px"}}> 
        <Container fluid>
          {encodedId === null || entityName  && <Breadcrumbs title="Schedule Meeting" />}
          <Row className={(encodedId && entityName) || (!encodedId && !entityName) ? "vertical-scroll" : ""}>
            <Col xs="12">
              <div>
                <div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleBlur,
                      setFieldValue,
                      handleChange,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <h5 style={{ marginTop: "1%",color:"#21aa47" }}>Schedule Meeting</h5>

                        {encodedId ? (
                            <Row className="mb-3">
                            <Col sm="6">
                              <Label className="form-label">Entity</Label>
                              <Input
                                type="text"
                                name="entity"
                                id="entity"
                                value={entity}
                                disabled
                              />
                            </Col>
                           {encodedIdDeal ? (
                              <Col sm="6">
                                <Label className="form-label">Deal</Label>
                                <Input
                                  type="text"
                                  name="entity"
                                  id="entity"
                                  value={dealName}
                                  disabled
                                />
                              </Col>
                            ) :
                              dealList?.length > 0 && (
                                <Col sm="6">
                                <Label className="form-label">Select Deal</Label>
                                <Select
                                  name="deal"
                                  options={dealList.map((deal) => ({
                                    value: deal.id,
                                    label: deal.dealName,
                                  }))}
                                  onChange={(selectedOption) => {
                                    const selectedValue = selectedOption ? selectedOption.value : "";
                                    setFieldValue("deal", selectedValue);
                                    handleDealChange({ target: { value: selectedValue } });
                                  }}
                                  value={
                                    values.deal
                                      ? {
                                        value: values.deal,
                                        label: dealList.find((deal) => deal.id === values.deal).dealName,
                                      }
                                      : null
                                  }
                                  classNamePrefix="select"
                                  className={touched.deal && errors.deal ? "is-invalid" : ""}
                                  isSearchable={true}
                                  isClearable={true}
                                />
                                {touched.deal && errors.deal && (
                                  <FormFeedback className="d-block">{errors.deal}</FormFeedback>
                                )}
                              </Col>
                              )
                            }
                          </Row>
                        ) : (

                          <Row className="mb-3">
                            <Col sm="6">
                              <Label className="form-label mt-4">Select Entity*</Label>
                              <Select
                                name="entity"
                                options={entityList.map((item) => ({
                                  value: item.id,
                                  label: item.entityName,
                                }))}
                                onChange={(selectedOption) => {
                                  const selectedValue = selectedOption ? selectedOption.value : "";
                                  setFieldValue("entity", selectedValue);
                                  handleEntityChange({ target: { value: selectedValue } });
                                }}
                                value={
                                  values.entity
                                    ? {
                                      value: values.entity,
                                      label: entityList.find((item) => item.id === values.entity).entityName,
                                    }
                                    : null
                                }
                                classNamePrefix="select"
                                className={touched.entity && errors.entity ? "is-invalid" : ""}
                                isSearchable={true}
                                isClearable={true}
                              />
                              {touched.entity && errors.entity && (
                                <FormFeedback className="d-block">{errors.entity}</FormFeedback>
                              )}
                            </Col>

                            {showNestedDropdown && (
                              <Col sm="6">
                                <Label className="form-label mt-4">Select Deal</Label>
                                <Select
                                  name="deal"
                                  options={dealList.map((deal) => ({
                                    value: deal.id,
                                    label: deal.dealName,
                                  }))}
                                  onChange={(selectedOption) => {
                                    const selectedValue = selectedOption ? selectedOption.value : "";
                                    setFieldValue("deal", selectedValue);
                                    handleDealChange({ target: { value: selectedValue } });
                                  }}
                                  value={
                                    values.deal
                                      ? {
                                        value: values.deal,
                                        label: dealList.find((deal) => deal.id === values.deal).dealName,
                                      }
                                      : null
                                  }
                                  classNamePrefix="select"
                                  className={touched.deal && errors.deal ? "is-invalid" : ""}
                                  isSearchable={true}
                                  isClearable={true}
                                />
                                {touched.deal && errors.deal && (
                                  <FormFeedback className="d-block">{errors.deal}</FormFeedback>
                                )}
                              </Col>
                            )}
                          </Row>
                        )}

                        <Row className="mb-3">
                          <Col sm="12">
                            <Label className="form-label mt-4">Title*</Label>
                            <Input
                              type="text"
                              name="title"
                              placeholder="Enter Meeting Title"
                              onChange={handleChange}
                              value={values.title}
                              invalid={touched.title && !!errors.title}
                            />
                            {touched.title && errors.title && (
                              <FormFeedback>{errors.title}</FormFeedback>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="4">
                            <Label className="form-label mt-4">Date*</Label>
                            <Input
                              type="date"
                              name="date"
                              onChange={handleChange}
                              value={values.date}
                              invalid={touched.date && !!errors.date}
                              min={currentDate}
                            />
                            {touched.date && errors.date && (
                              <FormFeedback>{errors.date}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="4">
                            <Label className="form-label mt-4">Time(From)*</Label>
                            <Input
                              type="time"
                              name="startTime"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.startTime}
                              invalid={touched.startTime && !!errors.startTime}
                            />
                            {touched.startTime && errors.startTime && (
                              <FormFeedback>{errors.startTime}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="4">
                            <Label className="form-label mt-4">Time(To)*</Label>
                            <Input
                              type="time"
                              name="endTime"
                              onChange={handleChange}
                              value={values.endTime}
                              invalid={touched.endTime && !!errors.endTime}
                            >
                            </Input>
                            {touched.endTime && errors.endTime && (
                              <FormFeedback>{errors.endTime}</FormFeedback>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="6">
                            <Label className="form-label mt-4">TimeZone</Label>
                            <Input
                              type="select"
                              name="timezone"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.timezone}
                              // invalid={touched.timezone && !!errors.timezone}
                            >
                              <option value="" label="Select Timezone" disabled />
                              {timezones.map((timezone) => (
                                <option key={timezone.value} value={timezone.value}>
                                  {timezone.label}
                                </option>
                              ))}
                              
                            </Input>
                            {/* {touched.timezone && errors.timezone && (
                              <FormFeedback>{errors.timezone}</FormFeedback>
                            )} */}
                          </Col>

                          <Col sm="6">
                            <Label className="form-label mt-4">Status*</Label>
                            <Input
                              type="select"
                              name="meetingStatus"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.meetingStatus}
                              invalid={touched.meetingStatus && !!errors.meetingStatus}
                            >
                              <option value="" label="Select Status" disabled />
                              {meetingStatus.map((item) => (
                                <option key={item.id} value={item.dropdownValue}>
                                  {item.displayName}
                                </option>
                              ))}
                              
                            </Input>
                            {touched.meetingStatus && errors.meetingStatus && (
                              <FormFeedback>{errors.meetingStatus}</FormFeedback>
                            )}
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="4">
                            <Label className="form-label mt-4">Invitees*</Label>
                            <Select
                              isMulti
                              name="invitees"
                              options={invitees}
                              onChange={(selectedOption) => setFieldValue("invitees", selectedOption)}
                              onInputChange={handleOptionChange}
                                inputValue={inputValue}
                                isSearchable
                                isClearable
                                noOptionsMessage={() => (
                                  <div>
                                    No options found. 
                                    <a href="#" onClick={(e) => {
                                      e.preventDefault();
                                      handleCreateInvitees();
                                    }}>Add "{inputValue}"</a>
                                  </div>
                                )}
                              value={values.invitees}
                              styles={customStyles}
                              className={touched.invitees && errors.invitees ? 'is-invalid' : ''}
                            />
                            {touched.invitees && errors.invitees && (
                              <FormFeedback>{errors.invitees}</FormFeedback>
                            )}
                          </Col>

                          <Col sm="4">
                            <Label className="form-label mt-4">Medium</Label>
                            <Input
                              type="select"
                              name="medium"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.medium}
                              invalid={touched.medium && !!errors.medium}
                            >
                              <option value="" label="Select Medium" disabled />
                              {medium.map((item) => (
                                <option key={item.id} value={item.dropdownValue}>
                                  {item.displayName}
                                </option>
                              ))}
                              
                            </Input>
                            {touched.medium && errors.medium && (
                              <FormFeedback>{errors.medium}</FormFeedback>
                            )}
                          </Col>
                          <Col sm="4">
                            <Label className="form-label mt-4">Location</Label>
                            <Input
                              type="text"
                              name="location"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.location}
                            >          
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="12">
                            <Label className="form-label mt-4">Description</Label>
                            <JoditEditor
                              ref={editor}
                              value={values.description}
                              config={config} 
                              onChange={(newContent) => setFieldValue("description", newContent)}

                            />
                            {/* {touched.description && errors.description && (
                              <FormFeedback>{errors.description}</FormFeedback>
                            )} */}
                          </Col>
                        </Row>

                        <div className="d-flex justify-content-end">
                          <Button
                            type="submit"
                            style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }}
                            className="me-2"
                          >
                            Schedule
                          </Button>
                          <Button type="button" 
                            onClick={handleCancel}
                            outline
                            >
                            Cancel
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

ScheduleMeetngForm.defaultProps = {
  onCancel: () => {
    window.history.back();
  },
  onSchedule: () => {
    window.history.back();
  },
};

export default ScheduleMeetngForm;



